import { useModels, type PredictiveModelRow } from "@/hooks/useModels";
import { useModelWorkspace } from "@/contexts/ModelWorkspaceContext";

/**
 * The model every panel on the Predictive Models page is looking at:
 * the one just trained/selected, otherwise the most recent one.
 */
export const useSelectedModel = (): {
  model: PredictiveModelRow | null;
  models: PredictiveModelRow[];
  isLoading: boolean;
} => {
  const { models, isLoading } = useModels();
  const { selectedModelId } = useModelWorkspace();
  const model =
    models.find((m) => m.id === selectedModelId) ?? models[0] ?? null;
  return { model, models, isLoading };
};
